import { Donation } from 'api/general/models';
import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { stateFactories, actionsHandlers } from 'store/entities/utils';
import { EntityType } from 'store/entities/types';
import * as actions from './actions';

const stateFactory = stateFactories.createInitialEntitiesStateFactory<EntityType<Donation>>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const donationsReducer = createReducer<State, Actions>(initialState, {
  [actions.getEventDonation.request.type]: actionsHandlers.handleGetOneRequest,
  [actions.getEventDonation.success.type]: actionsHandlers.handleGetOneSuccess,
  [actions.getEventDonation.failure.type]: actionsHandlers.handleGetOneFailure,
  [actions.getEventDonation.reset.type]: actionsHandlers.handleGetOneReset,
});

export default donationsReducer;
